import {
  ThicknessAnalysis,
  ThicknessFaceSummary,
  ThicknessRegion,
} from '../../../types/cad';

export type ThicknessDisplayMode = 'smooth' | 'flat';

export interface ThicknessViewState {
  analysis: ThicknessAnalysis | null;
  region: ThicknessRegion | null;
  displayMode: ThicknessDisplayMode;
}

export type BadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline'
  | 'success'
  | 'warning'
  | 'info';

// Radix Select throws when a SelectItem carries an empty value, and mapping the
// "no preset" row to a sentinel keeps the trigger controlled with a real string.
export const PRESET_NONE = '__cad_thickness_preset_none__';
// Placeholders with no matching item render the SelectValue placeholder, so the
// trigger stays a controlled string even when nothing is selected yet.
export const RUN_NONE = '__cad_thickness_run_none__';
export const COMPARE_NONE = '__cad_thickness_compare_none__';

export const statusBadgeVariant = (
  status: ThicknessAnalysis['status'],
): BadgeVariant => {
  if (status === 'completed') return 'success';
  if (status === 'failed') return 'destructive';
  if (status === 'processing') return 'info';
  return 'secondary';
};

export const faceSummaryChip = (
  face: ThicknessFaceSummary,
): {
  variant: BadgeVariant;
  key: string;
} => {
  if (
    (face.finalCounts.thin || 0) > 0
    && (face.finalCounts.thick || 0) > 0
  ) {
    return { variant: 'warning', key: 'mixed' };
  }
  if (face.finalJudgment === 'thin') {
    return { variant: 'destructive', key: 'thin' };
  }
  if (face.finalJudgment === 'thick') {
    return { variant: 'info', key: 'thick' };
  }
  if (face.finalJudgment === 'within_range') {
    return { variant: 'success', key: 'within_range' };
  }
  return { variant: 'secondary', key: 'unmeasured' };
};
